import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_HALAL_STOCK_ORDERS } from "../../../config/api";

export const getStockOrders = createAsyncThunk(
  "stocks/getOrders",
  async (arg = {}, { rejectWithValue }) => {
    const { side = "buy", ...queryParams } = arg || {};
    try {
      const response = await Client({
        method: "GET",
        path: API_HALAL_STOCK_ORDERS(side),
        queryParams,
      });

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      return rejectWithValue(error.message);
    }
  }
);
